import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.digitalFolderSettings],
        config: {
            headerName: getLocalizedString("positionCode"),
            field: "code",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                // we put checkbox on the name if we are not doing grouping
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.digitalFolderSettings],
        config: {
            headerName: getLocalizedString("positionEditorPositionName"),
            field: "valueCargo",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.digitalFolderSettings],
        config: {
            headerName: getLocalizedString("instance"),
            field: "valueInstanciaLaboral",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.digitalFolderSettings],
        config: {
            headerName: getLocalizedString("documentMandatory"),
            field: "valueTipoDocumento",
            filter: "agSetColumnFilter",
        }
    },
]